import React, { createContext, useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog as MuiDialog, DialogTitle as MuiDialogTitle, IconButton } from '@mui/material';

const DialogCloseContext = createContext(null);

export function Dialog({ children, onClose, ...props }) {
  return <MuiDialog onClose={onClose} {...props}>
    <DialogCloseContext.Provider value={onClose}>{children}</DialogCloseContext.Provider>
  </MuiDialog>;
}

export function DialogTitle({ children, closeLabel = 'Close dialog', ...props }) {
  const onClose = useContext(DialogCloseContext);
  return <MuiDialogTitle {...props} sx={[{ position: 'relative', paddingRight: 7 }, ...(Array.isArray(props.sx) ? props.sx : props.sx ? [props.sx] : [])]}>
    {children}
    {typeof onClose === 'function' && <IconButton
      aria-label={closeLabel}
      onClick={(event) => onClose(event, 'closeButton')}
      size="small"
      sx={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)' }}
    ><CloseIcon /></IconButton>}
  </MuiDialogTitle>;
}
